import React, {
  FC,
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  AuthenticatedState,
  AuthenticatorNameState,
  FacesState,
  FacialDataState,
  LoginPhoneNumberState,
  SignnPropsState,
} from "states";
import { FacesPipelineState } from "states";
import { useRecoilState, useRecoilValue } from "recoil";
import { Button, Loader } from "@storybook";
import { IFaceMatch } from "./utils";
import {
  Face,
  apiCall,
  useWebAuthentication,
  useNetwork,
  token,
  API_HOST,
} from "hooks";
import { useFace } from "hooks";
import { API_URL } from "constant";
import "./face-auth.scss";

interface IsetIsAuth {
  onSuccess: Function;
}

function extractValues(fullName: string) {
  const regex = /(.*) <(.*)>/;
  const matches = fullName.match(regex);
  
  if (matches && matches.length === 3) {
    const name = matches[1].trim();
    const value = matches[2];
    
    return { name, value };
  }
  
  return null;
}

export const FaceAuth: FC<IsetIsAuth> = ({ onSuccess }) => {
  const facesData = useRecoilValue<IFaceMatch[]>(FacesState);
  const [currentUserImage, setCurrentUserImage] = useState("");
  const [recipientInfo, setReciptentInfo] = useState();
  const signnPropsState = useRecoilValue(SignnPropsState);
  const facesPipelineData = useRecoilValue<IFaceMatch>(FacesPipelineState);
  const [ recipientData , setRecipientData ]= useState<any>({});
  const [loadModal, setModal] = useState(true)
  const [imageNext, setImageNExt] = useState(false)

  console.log("signnPropsState", signnPropsState);
  console.log("recpt info", recipientInfo);

  const handleMatchUser = useCallback((id: string) => {
    console.log("called ar");
    const checkUser = setInterval(async () => {
      fetch(API_HOST + API_URL.REQUEST_RECIPIENT + "/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((resp) => {
          console.log("verify", resp);
          setRecipientData(resp.data) 
          if (resp?.data?.status === "complete") {
            clearInterval(checkUser);
            // const recipient = { recipient_img  : resp.data.image, recipient_id: resp.data._id}
            // setTimeout(() => {
            //   onSuccess(currentUserImage, recipient);
            // }, 1000)
          }
        })
        .catch((error) => console.log(error));
    }, 2000);
  }, []);

  const [isCompleted, setIsCompleted] = useState(false);
  // const [authenticatorName, setAuthenticatorName] = useState("Unknown");
  const faceialData = useRecoilValue(FacialDataState);
  const [authenticated, setAuthenticated] = useRecoilState(AuthenticatedState);
  const [authenticatorName, setAuthenticatorName] = useRecoilState(
    AuthenticatorNameState
  );

  const [isLoading, setIsLoading] = useState(false);
  const [isAPIcalled, setIsAPICalled] = useState(false);
  // const [authenticated, setAuthenticated] = useState(false);
  const [state, setState] = useState({
    face_id: "Unknown",
    confidence: 0,
    matched: false,
    liveness: true,
  });

  useEffect(() => {
    console.log(faceialData, "Face.apiCalling", Face.apiCalling);
    if (faceialData?._id && Face.apiCalling) {
      apiCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [faceialData._id]);

  // useEffect(() => {
  //   Face.emitter.on(Face.events.FACE_MATCH, (data) => {
  //     Face.facial
  //       ?.match(Face.camera?.video, {
  //         height: Face.camera?.video.videoHeight,
  //         width: Face.camera?.video.videoWidth,
  //       })
  //       .then((matches) => {
  //         setFaces(matches);
  //       })
  //       .catch((err) => {
  //         console.log("err", err);
  //       });
  //     // setFaces(data)
  //   });
  // }, [])

  const { setupCanvas } = useFace();
  const { phone } = useRecoilValue(LoginPhoneNumberState);

  useEffect(() => {
    setupCanvas();
  }, []);

  const getUserImage = useCallback(() => {
    const canvas = document.getElementById("output") as HTMLCanvasElement;
    const video = document.getElementById("video") as HTMLVideoElement;
    canvas
      ?.getContext("2d")
      ?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    return canvas.toDataURL("image/jpeg").split(";base64,")[1];
  }, []);

  const handleSuccess = useCallback(() => {
   
    setTimeout(() => {
      setIsLoading(false);
      if (signnPropsState.is_recipient || !signnPropsState.is_message_send) {
        setIsCompleted(true);
        onSuccess(currentUserImage);
        return
      }
      if (signnPropsState.is_message_send) {
        let data = document.getElementById('txtToValue') as HTMLInputElement | null;
        const value = data?.value
        const payload = {
          // name: "Abhishek Mahra",
          // phone: "8939155935",
          // countryCode: "+91",
          name: "Alina Trombley",
          phone: "4157416782",
          countryCode: "+1",
          image: "abc",
        }
        if (value) {
          try {
            const fullName = value;
            const extractedData = extractValues(fullName);
            // payload.phone = extractedData?.value ?? "7349235825";
            // Uncomment for alina number
            payload.name = extractedData?.name ?? "Alina Trombley";
            payload.countryCode = "+1"
            payload.phone = extractedData?.value ?? "4157416782";
          } catch(err) {
            console.log("error", err)
          } 
        }
        
        fetch(`${API_HOST + API_URL.REQUEST_RECIPIENT}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json())
          .then((resp) => {
            if (resp) {
              console.log("resp", resp);
              setIsCompleted(true);
              setImageNExt(true)
              handleMatchUser(resp?.data?._id);
            }
          })
          .catch((error) => console.log(error));
      }
    }, 1000);
  }, [currentUserImage, handleMatchUser, onSuccess, signnPropsState.is_message_send, signnPropsState.is_recipient]);

  const handleFail = useCallback(() => {}, []);

  const { getRegistrations, registerNewCredentials, authenticate } =
    useWebAuthentication();

  const handleWebAuth = useCallback(() => {
    const isAlreadyExist = getRegistrations().find(
      (item: any) => item.name === phone ?? ""
    );
    const registerPayload = {
      email: phone ?? "",
      id: phone ?? "",
      displayName: phone ?? "",
    };
    // handleSuccess();

    if (!isAlreadyExist) registerNewCredentials(handleSuccess, registerPayload);
    else authenticate(handleSuccess, handleFail);
  }, [authenticate, getRegistrations, handleFail, handleSuccess, phone, registerNewCredentials]);

  const handleOnNext = useCallback(() => {
    handleWebAuth();
  }, [handleWebAuth]);

  const renderStatus = useMemo(() => {
    if (!authenticated){
      return "Fetching..."
    }
    return <Button
      type="button button__filled--primary button__large button__block "
      label="Next"
      handleClick={handleOnNext}
    />
  }, [authenticated, handleOnNext]);

  const face: any = facesData[0] ?? { match: {} };
  // console.log("face", face, faceialData);

  const name = useMemo(() => {
    if (Object.keys(facesPipelineData)) {
      if (authenticated) {
        return authenticatorName;
      }

      // test
      if (facesPipelineData.match) {
        const { _label: faceLabel, _distance: faceDistance } =
          (facesPipelineData as any)?.match ?? {};
        if (faceDistance === 0 || faceDistance === undefined) {
          return "unknown";
        }

        // if (faceLabel === faceialData.name) {
        if (!authenticated) {
          setAuthenticatorName(faceialData.name);
          Face.matchedUserName = faceialData.name;
          Face.matched = true;
          setTimeout(() => {
            setAuthenticated(true);
          }, 150);
        }
        // }
        return faceialData.name;
      }
    }

    const distance = face.match._distance ?? face.match.distance;
    const label = face.match._label ?? face.match.label;

    if (authenticated) {
      return authenticatorName;
    }

    if (distance === 0 || distance === undefined) {
      return "unknown";
    }
    if (label === faceialData.name) {
      if (!authenticated) {
        setAuthenticatorName(faceialData.name);
        Face.matched = true;
        setTimeout(() => {
          setAuthenticated(true);
        }, 150);
      }
    }
    return authenticatorName;
    //return authenticatorName ?? face.match.label;
  }, [
    facesPipelineData,
    face.match._distance,
    face.match.distance,
    face.match._label,
    face.match.label,
    authenticated,
    faceialData.name,
    authenticatorName,
    setAuthenticatorName,
    setAuthenticated,
  ]);

  useEffect(() => {
    if (authenticated && !currentUserImage) {
      setTimeout(() => {
        const image = getUserImage();
        console.log({ image });
        setCurrentUserImage(image);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  console.log(
    { authenticatorName, authenticated },
    face.match._distance ?? face.match.distance
  );


  const handleNextPay = useCallback(() => {
    const recipient = { recipient_img  : recipientData.image, recipient_id: recipientData._id}
    onSuccess(currentUserImage, recipient);
  }, [currentUserImage, onSuccess, recipientData._id, recipientData.image])

  const width = window.innerWidth < 500 ? window.innerWidth : 500;

  // useEffect(() => {
  //   if (signnPropsState.is_recipient) {
  //     setTimeout(() => {
  //       setModal(true)
  //     }, 1000)
  //   } else {
  //     setModal(true)
  //   }
  // }, [signnPropsState.is_recipient])
  // const loading = isLoading || isAPIcalled || !facialLoaded.current;
  const loading = isLoading && loadModal;

  const renderMainComponent = useMemo(() => {
    if (!isCompleted) {
      return (
        <Fragment>
          {!isAPIcalled && !isLoading && (
            <div style={{ fontWeight: "500", fontSize: "20px" }}>
              Name: {name}
            </div>
          )}

          {loading && (
            <>
              <div
                style={{
                  width: "300px",
                  height: "300px",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <div>
                  <Loader />
                  Loading
                </div>
              </div>
            </>
          )}
          <div
            className="container"
            style={{
              display: loading ? "none" : "block",
            }}
          >
            <div className="canvas-wrapper">
              <canvas id="output"></canvas>
            </div>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              {renderStatus}
            </div>
          </div>
        </Fragment>
      );
    }

    if (imageNext && !signnPropsState.is_recipient){
      const recipientImg = recipientData.image ? recipientData.image === "abc" ? null : `data:image/svg+png;base64,${recipientData.image}` : null;
      return <div
      style={{
        width: width,
        height: width,
        display: "grid",
        placeItems: "center",
      }}
    >
      <div style={{
            height: "100%",
            width: "100%"
          }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            height: "100%",
          }}
        >
          {
            !recipientImg ? <>
            <div className="ban-poc-loader"></div>
              <p>Waiting for recipient approval</p>
            </>: null
          }
          
          {
            recipientImg ? <div className="bank-poc-img__wrapper">
              <img alt="image_url" src={recipientImg}/>
            </div> : null
          }
          { recipientData?.status === "complete" ?
            <Button
              type="button button__filled--primary button__large button__block "
              label="Next"
              handleClick={handleNextPay}
            /> : null
          }
        </div>
      </div>
    </div>
    }
    return (
      <div
        style={{
          width: width,
          height: width,
          display: "grid",
          placeItems: "center",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <i
              style={{ fontSize: "48px", color: "green" }}
              className="ri-checkbox-circle-line"
            ></i>
            <div> Authenticated Successfully </div>
          </div>
        </div>
      </div>
    );
  }, [isCompleted, imageNext, signnPropsState.is_recipient, width, isAPIcalled, isLoading, name, loading, renderStatus, recipientData.image, recipientData?.status, handleNextPay]);

  return renderMainComponent;
};
